import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import {nameValidation, emailValidation} from '../../../../utils/itemValidation';
import {cloneArray} from '../../../../utils/data';

import * as commonActionCreators from '../../../../actions/common';
import * as userActionCreators from '../../../../actions/user';
let allActionCreators = Object.assign({}, commonActionCreators, userActionCreators);

import AntiModal from '../../../common/modal/AntiModal';

import {WishlistProductContainer} from './WishlistProduct';

class AccountWishlist extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);
		this.state = {

      requestPending: false,
      serverError: null,

      sortOpen: false,
      sortValue: '',

      shareModalOpen: false,
      shareName: '',
      shareNameError: null,
      shareEmail: '',
      shareEmailError: null,
      toShareId: null,

      nameOpen: false,
      nameValue: '',
      nameError: null,

      confirmModalOpen: false,
      toDeleteId: null,
    };
	}

	componentDidMount() {

  }

  fetchWishlists() {
    return this.props.user.wishlists ? this.props.user.wishlists : [];
  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  toggleSortOpen() {
    this.setState({ sortOpen: !this.state.sortOpen });
  }

  updateSort(val) {
    this.setState({ sortValue: val });
  }

  changeShareName(evt) {
    this.setState({ shareName: evt.target.value });
  }

  validateShareName() {
    this.setState({ shareNameError: nameValidation(this.state.shareName) });
  }

  changeShareEmail(evt) {
    this.setState({ shareEmail: evt.target.value });
  }

  validateShareEmail() {
    this.setState({ shareEmailError: emailValidation(this.state.shareEmail) });
  }

  openShareModal(listId) {
    this.setState({ 
      shareModalOpen: true, 
      toShareId: listId,
    });
  }

  closeShareModal() {
    this.setState({
      shareModalOpen: false,
      shareName: '',
      shareNameError: null,
      shareEmail: '',
      shareEmailError: null,
      requestPending: false,
      serverError: null,
      toShareId: null,
    })
  }

  validateAll() {
    let nameError = nameValidation(this.state.shareName);
    let emailError = emailValidation(this.state.shareEmail);

    this.setState({
      shareNameError: nameError,
      shareEmailError: emailError,
    });

    if(nameError === null && emailError === null) {
      return true;
    } else {
      return false;
    }
  }

  handleSubmit(evt) {

    evt.preventDefault();
    if(this.validateAll()) {
      this.setState({
        requestPending: true,
      });
      this.props.userShareWishlist(this.state.toShareId, this.state.shareName, this.state.shareEmail)
      .then(() => {
        this.props.commonAlert('Wishlist shared!', null);
        this.closeShareModal();
      });
    }
  }

  toggleNameOpen() {
    this.setState({ nameOpen: !this.state.nameOpen });
  }

  changeName(evt) {
    this.setState({ nameValue: evt.target.value });
  }

  createWishlist() {
    if(!this.state.nameValue) {
      return;
    }

    this.toggleNameOpen();

    this.props.userCreateWishlist(this.state.nameValue)
    .then((resp) => {
      
      this.props.userGetWishlists()
      .then((respData) => {
        this.props.userSaveWishlists(respData.wishlists);
      });

      this.setState({
        nameValue: '',
        nameError: null,
      });
    });
  }

  deleteList(listId) {

    if(!listId) {
      return;
    }

    this.props.userDeleteWishlist(listId)
    .then((resp) => {      
      this.props.userGetWishlists()
      .then((respData) => {
        this.props.userSaveWishlists(respData.wishlists);
      });
      this.closeConfirmModal();
    });
  }

  openConfirmModal(listId) {
    this.setState({ 
      confirmModalOpen: true,
      toDeleteId: listId
    });
  }

  closeConfirmModal() {
    this.setState({ 
      confirmModalOpen: false,
      toDeleteId: null 
    });
  }

	render() {
		return <div className='AccountWishlist'>
      <div className='sectionTitle'>
        Your Wishlists
        <div className={this.state.sortOpen ? 'wishlistSortDropdown open' : 'wishlistSortDropdown'} onClick={::this.toggleSortOpen}>
          <div className='wishlistLabel'>
            <div className='wlLabelValue'>Sort by {this.state.sortValue}</div>
            <div className='wlIcon'>
              <i className={'fas fa-chevron-right'}></i>
            </div>
          </div>
          <div className='wishlistLabelBody' style={{display: 'none'}}>
            <div className='wishlistLabelBodyWrapper'>
              <div className='sortItem' onClick={() => this.updateSort('Name')}>Name</div>
              <div className='sortItem' onClick={() => this.updateSort('Date Created')}>Date Created</div>
            </div>
          </div>
        </div>
      </div>
      <div className='wishlistSectionWrapper'>

        {this.fetchWishlists().length === 0 ?
          <div className={'nullOrder'}>No wishlists created.</div> :
          null
        }

        {this.fetchWishlists().map((wishlist, i) => {
          return <div className='wishlistWrapper' key={i}>
            <div className='wishlistNameWrapper'>
              <div className='wishlistNameValue'>{wishlist.name}</div>
              <div className='wishlistShare' onClick={() => this.openShareModal(wishlist.id)}>
                <div className='shareIcon'>
                  <img src='https://ddw2.diamondsdirect.com/img/account/share.svg' />
                </div>
                <div className='shareText'>Share</div>
              </div>
              <div className='wishlistDeleteIcon' onClick={() => this.openConfirmModal(wishlist.id)}>
                <img src='https://ddw2.diamondsdirect.com/img/account/smallx.svg' />
              </div>
            </div>
            <div className='wishlistProductsWrapper'>
              {wishlist.items && wishlist.items.length === 0 ?
                <div className='nullOrder'>No special pieces yet...</div> :
                <div>
                  {wishlist.items.map((product, j) => {
                    return <WishlistProductContainer 
                            key={j}
                            sku={product.sku} 
                            wishlistId={wishlist.id}
                            itemId={product.id} />
                  })}
                </div>
              }
            </div>
          </div>;
        })}
      </div>
      <div className='createWrapper'>
        <div className='createLink'>
          {this.state.nameOpen ?
            <div className='createLinkIcon'>-</div> :
            <div className='createLinkIcon'>+</div>
          }
          <div className='createLinkValue' onClick={::this.toggleNameOpen}>Create new wishlist</div>
          <div className={this.state.nameOpen ? 'createForm expanded' : 'createForm'}>
            <div className='cfInner'>
              <div className='cfInput'>
                <input
                  type='text'
                  value={this.state.nameValue}
                  onChange={::this.changeName} />
              </div>
              <div className='cfButton' onClick={::this.createWishlist}>+ Add</div>
            </div>
          </div>
        </div>
      </div>
      <AntiModal 
        open={this.state.confirmModalOpen} 
        closeMethod={::this.closeConfirmModal}
        resize={this.props.common.modalResize}
        theme={'wishlistShare wishlistDeleteConfirm'}>
        <div className='shareModalWrapper'>
          <div className='shareClose' onClick={::this.closeConfirmModal}>
            <div className='closeX'>&times;</div>
          </div>
          <div className='shareModalTitle'>Are you sure?</div>
          <div className='shareModalHr'>
            <img src='https://ddw2.diamondsdirect.com/img/account/iconline_1.svg' />
          </div>
          <div className='shareModalText'>This action can't be undone</div>
          <div className='shareButtonWrapper'>
            <div className='shareSecondary' onClick={::this.closeConfirmModal}>Cancel</div>
            <div className='sharePrimary' onClick={() => this.deleteList(this.state.toDeleteId)}>Delete</div>
          </div>
        </div>
      </AntiModal>
      <AntiModal 
        open={this.state.shareModalOpen} 
        closeMethod={::this.closeShareModal}
        resize={this.props.common.modalResize}
        theme={'wishlistShare'}>
        <div className='shareModalWrapper'>
          <div className='shareClose' onClick={::this.closeShareModal}>
            <div className='closeX'>&times;</div>
          </div>
          <div className='shareModalTitle'>Share Your Wishlist</div>
          <div className='shareModalHr'>
            <img src='https://ddw2.diamondsdirect.com/img/account/iconline_1.svg' />
          </div>
          <div className='shareFormWrapper'>
            <form onSubmit={::this.handleSubmit} className='shareForm'>
              <div className='shareInputRow'>
                <div className='shareInputLabel'>Share With:</div>
                <div className='shareInputWrapper'>
                  <input
                    type='text'
                    value={this.state.shareName}
                    onChange={::this.changeShareName}
                    onBlur={::this.validateShareName}
                    className={this.state.shareNameError ? 'shareInput error' : 'shareInput'}
                    placeholder='Enter Name' />
                </div>
                {this.state.shareNameError ?
                  <div className='shareInputError'>{this.state.shareNameError}</div> :
                  null
                }
              </div>
              <div className='shareInputRow'>
                <div className='shareInputLabel'>Email:</div>
                <div className='shareInputWrapper'>
                  <input
                    type='email'
                    value={this.state.shareEmail}
                    onChange={::this.changeShareEmail}
                    onBlur={::this.validateShareEmail}
                    className={this.state.shareEmailError ? 'shareInput error' : 'shareInput'}
                    placeholder='Enter Email' />
                </div>
                {this.state.shareEmailError ?
                  <div className='shareInputError'>{this.state.shareEmailError}</div> :
                  null
                }
              </div>
              <div className='shareInputRow'>
                <div className='shareSubmitWrapper'>
                  <button 
                    type='submit'
                    className={'shareSubmitButton dd2ActionButton'}
                    disabled={this.state.requestPending}>Share</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </AntiModal>
		</div>;
	}
}
export default AccountWishlist;

function mapStateToProps(state) {
  return {
    common: state.common,
    user: state.user,
  };
}

export const AccountWishlistContainer = connect(
  mapStateToProps,
  allActionCreators
)(AccountWishlist);


// WEBPACK FOOTER //
// ./src/components/views/account/blocks/AccountWishlist.jsx